/**
 * Right after the first sign-in in the phone app: one question, "Use Face ID / fingerprint?". Asked once;
 * a "no" is final here and the switch lives in Settings → Security from then on (no banner on the home screen).
 */
import { useEffect, useState } from 'react';
import { useT } from '../i18n.ts';
import { declineFaceIdOffer, enableFaceId, faceIdKind, faceIdOn, shouldOfferFaceId, type FaceIdKind } from '../faceid.ts';
import { Dialog } from './Dialog.tsx';

export function FaceIdOffer() {
  const t = useT();
  const [kind, setKind] = useState<FaceIdKind>(null);
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!shouldOfferFaceId()) return;
    void faceIdKind().then(async (k) => {
      if (!k) return;
      if (await faceIdOn()) declineFaceIdOffer(); // already on: never ask
      else setKind(k);
    });
  }, []);
  if (!kind) return null;
  const android = kind === 'android';
  const title = kind === 'touch' ? 'Touch ID' : android ? t('bioTitle') : 'Face ID';
  const no = () => {
    declineFaceIdOffer();
    setKind(null);
  };
  const yes = async () => {
    setBusy(true);
    setFailed(false);
    try {
      await enableFaceId();
      setKind(null);
    } catch {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog title={title} onClose={no}>
      <div className="stack">
        <p>{android ? t('bioOffer') : t('faceIdOffer')}</p>
        <p className="muted small">{t('faceIdOfferHint')}</p>
        {failed && <p className="form-error small" role="alert">{t('faceIdFailed')}</p>}
        <div className="dialog-actions">
          <button className="btn" onClick={no} disabled={busy}>{t('faceIdNo')}</button>
          <button className="btn primary" onClick={() => void yes()} disabled={busy}>{t('faceIdYes')}</button>
        </div>
      </div>
    </Dialog>
  );
}
